import axiosInstance from '../../axiosInstance';

const addSharingToForUser = async ({ userId, sharingToUserId }) => {
  await axiosInstance.post(
    `/api/admin/v2/users/${userId}/sharing-to-accounts/${sharingToUserId}`,
  );
};

export default addSharingToForUser;
